"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientPluginRuntime = exports.CLIENT_PLUGIN_RUNTIME_KEY = void 0;
const runtimeKey_1 = require("./runtimeKey");
Object.defineProperty(exports, "CLIENT_PLUGIN_RUNTIME_KEY", { enumerable: true, get: function () { return runtimeKey_1.CLIENT_PLUGIN_RUNTIME_KEY; } });
/**
 * Reads the installed runtime. Used by a plugin's web bundle entry.
 *
 * @returns The runtime installed on `globalThis`.
 * @throws If no runtime is installed (the bundle loaded before the host).
 */
const getClientPluginRuntime = () => {
    const runtime = globalThis[runtimeKey_1.CLIENT_PLUGIN_RUNTIME_KEY];
    if (!runtime) {
        throw new Error("Creature Chess client plugin runtime not installed - a plugin bundle loaded before the host");
    }
    return runtime;
};
exports.getClientPluginRuntime = getClientPluginRuntime;
